<template>
  <div class="row">
    <div class="col-md-12">
      <pulse-loader :loading="loading" :color="color" style="text-align: center"/>
    </div>
    <div class="col-md-6">
      <div class="form-group">
        <label>Проект</label>
        <select @change="loadLetter" class="form-control" v-model="letter.site_id">
          <option value="0">Мастер шаблон</option>
          <option v-for="(name, index) in projects" :key="index" :value="index">{{ name }}</option>
        </select>
      </div>
      <div class="form-group">
        <label>Тип письма</label>
        <select @change="loadLetter" class="form-control" v-model="letter.type">
          <option v-for="(type, index) in types" :key="index" :value="index">{{ type }}</option>
        </select>
      </div>
    </div>
    <div class="col-md-6">

      <div class="form-group">
        <label for="">Отправитель</label>
        <select v-model="letter.sender_account_id" class="form-control">
          <option v-for="a in senderAccounts" :value="a.id">{{ a.title }} ({{ a.login }})</option>
        </select>
      </div>
    </div>
    <div class="col-md-12">
      <div class="form-group">
        <label>Тема письма</label>
        <input type="text" class="form-control" name="subject"
               v-validate="'required|min:10|max:1000'"
               data-vv-as="Тема письма"
               placeholder="Ваш заказ..."
               v-model="letter.subject">
        <small class="form-text text-danger" v-if="errors.has('subject')">
          {{ errors.first('subject') }}
        </small>
      </div>
    </div>
    <div class="col-md-8">
      <template v-if="letter">
        <div>
          <label for="">Фиксированный блок</label>
          <ckeditor :editor="editor" v-model="letter.fixed_block" :config="editorConfig"></ckeditor>
        </div>
        <div>
          <label for="">Текст письма</label>
          <ckeditor :editor="editor" v-model="letter.body" :config="editorConfig"></ckeditor>
        </div>
      </template>
    </div>
    <div class="col-md-4">
      <p><strong>${fixedBlock}</strong> - фиксированный блок, который не доступен к редактированию при отправки</p>
      <p><strong>${preps}</strong> - препарат(ы)</p>
      <p><strong>${orderNo}</strong> - номер заявки</p>
      <p><strong>${site_source}</strong> - сайт, где был создан заказ</p>
      <p><strong>${preps_qnty_prices}</strong> - перпарат количество - сумма</p>
      <!--      <p><strong>${price}</strong> - cумма заяки</p>-->
      <p><strong>${total_price}</strong> - cумма заяки + доставка - скидка</p>
      <p><strong>${preps_price}</strong> - cумма заяки (стоимость всех препаратов)</p>
      <p><strong>${delivery_price}</strong> - стоимость доставки</p>
      <p><strong>${name}</strong> - имя клиента</p>
      <!--      <p><strong>${phone}</strong> - контактный телефон проекта</p>-->
      <p><strong>${card}</strong> - карта получателя</p>
      <p><strong>${cardHolder}</strong> - имя получателя</p>
      <p><strong>${postTrackNum}</strong> - почтовы трек номер</p>

    </div>
    <div class="col-md-12 text-right">
      <vue-ladda @click="updateLetter" button-class="btn btn-success"
                 data-style="zoom-in"
                 :loading="submit_form_loading">Сохранить
      </vue-ladda>
    </div>
  </div>
</template>

<script>

import api from '@/api'
import CKEditor from '@ckeditor/ckeditor5-vue';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import Multiselect from 'vue-multiselect'
import VueLadda from 'vue-ladda/src/vue-ladda.vue'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'

export default {
  components: {
    ckeditor: CKEditor.component,
    ClassicEditor,
    Multiselect,
    VueLadda,
    PulseLoader
  },
  props: {
    id: {
      default: 0,
      type: Number
    }
  },
  data() {
    return {
      color: '#5BBFDE',
      senderAccounts: [],
      loading: true,
      submit_form_loading: false,
      editor: ClassicEditor,
      editorConfig: {},
      editorData: '<p>Шаблон письма</p>',
      types: {},
      projects: {},
      cards: [],
      delayVisible: false,
      letter: {
        id: null,
        type: null,
        site_id: null,
        subject: null,
        body: '<p>Шаблон письма</p>',
        fixed_block: '',
        send_login: null,
        send_password: null,
        send_delay: null,
        is_active: 1,
        selected_cards: []
      },
      Toast: this.$swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000
      })
    }
  },
  async mounted() {
    await this.getLetterTypes()
    this.loadLetter()
  },
  methods: {
    resetLeter() {
      this.letter.id = null
      this.letter.id = null
      this.letter.subject = null
      this.letter.body = '<p>Шаблон письма</p>'
      this.letter.fixed_block = ''
      this.letter.send_login = null
      this.letter.send_password = null
      this.letter.send_delay = null
      this.letter.selected_cards = []
    },
    fillCards(cards) {
      if (!cards) return
      // let arr = JSON.parse(cardsJson);
      this.letter.selected_cards = []
      Object.keys(this.cards).forEach((key) => {
        if (cards.includes(this.cards[key].id)) this.letter.selected_cards.push(this.cards[key]);
      })

    },
    async loadLetter() {
      this.loading = true

      if (this.letter.type == 1 || this.letter.type == 3) {
        this.delayVisible = false;
        this.letter.send_delay = 0;
      } else {
        this.delayVisible = true;
      }

      this.resetLeter();
      let {data} = await api.store('/settings/letters/getLetter', {
        type: this.letter.type,
        site_id: this.letter.site_id
      })
      if (!data.letter) {
        this.loading = false
        return
      }
      if (!data.letter.fixed_block) data.letter.fixed_block = '';
      this.letter = data.letter;
      this.fillCards(data.letter.selected_cards)
      this.loading = false
    },
    async updateLetter() {
      const valid = await this.$validator.validateAll();
      if (!valid) return
      this.submit_form_loading = true;
      let {data} = await api.store('/settings/letters/updateLetter', {
        data: this.letter
      })
      if (data.success) {
        this.Toast.fire({
          type: 'success',
          title: 'Сохранено'
        })
      } else {
        this.Toast.fire({
          type: 'warning',
          title: 'Ошибка сохранения'
        })
      }
      this.submit_form_loading = false;
    },
    async getLetterTypes() {
      let {data} = await api.index('/settings/letters/getLetterTypes')
      this.types = data.types;
      this.senderAccounts = data.sender_accounts;
      this.projects = data.sites;

      this.letter.site_id = Object.keys(this.projects)[0];
      this.letter.type = Object.keys(this.types)[0];

      // let {data: data_cards} = await api.index('/settings/getCards?all=true')
      //
      // Object.keys(data_cards.cards).forEach((key) => {
      //   this.cards.push({
      //     name: data_cards.cards[key].number + ' ' + data_cards.cards[key].owner.short_name + '  (' + (data_cards.cards[key].type == 1 ? 'VISA)' : 'MASTER)'),
      //     id: data_cards.cards[key].id
      //   })
      // });

    }
  }
}

</script>
